export const TermsOfUseForAgent = `
## 第1条（本サービス及び本利用規約）
1. 本サービス利用規約（以下「本利用規約」といいます。）は、株式会社ワンキャリア（以下「当社」といいます。）が提供する本サービス（第5条において定義します。以下同じ。）の利用条件を定めるものです。本サービスを利用する企業（以下「利用企業」といいます。）は、本利用規約に従って本サービスを利用するものとします。
2. 本利用規約の内容は当社と利用企業との間の本契約の内容となります。ただし、当社が異議なく承諾した申込書等その他別途当社と利用企業との間で合意された覚書等に定める事項と本利用規約に定める事項とに相違を生じた場合、当該申込書等及び当該覚書等の規定が優先して適用されるものとします。



## 第2条（用語の定義）
本利用規約において使用する用語の定義は、以下の通りです。

a. 求人条件：職業安定法第5条の3第2項に定めに従い、同項に定める労働条件その他利用企業が希望する求⼈の条件（採⽤企業名、試⽤期間に関する事項等を含む。）のことをいいます。

b. 求人票：求⼈条件ごとにその具体的な内容を明⽰した、当社が指定した様式の⽂書のことをいいます。

c. 利用企業：本サービスを利用する企業のことをいいます。

d. 候補者：求⼈条件に適合可能性がある⼈材のことをいいます。

e. 応募者：候補者のうち、利用企業の社⾵等求⼈条件以外の条件を加味して当社が適切と判断した⼈材であり、かつ利用企業に応募する意思がある⼈材かつ、利用企業に対して紹介を行った人材のことをいいます。

f. 理論年収：別途申込書等に詳細の定義を定める、会社に1年間在籍した際に得られる年収のことをいいます。

g. 申込書等：当社が別途指定する書式で、利用企業が本サービスを利用するための申込みをする上で必要な事項を記載する書面又は必要な事項を記入する電子フォームをいいます。

h. 本契約：第4条の定めに従って当社と利用企業の間で締結される、本サービスの利用に関する契約をいいます。

i. 内定承諾：利用企業が、求人情報等に対するエントリーを行ったONE CAREER会員に対して求人情報（求人情報等を構成する求人情報のほか、利用企業がONE CAREER会員に対して直接間接問わず何らかの形で提供した全部の求人情報を含みます。）を提供し、当該求人情報に基づく選考活動が行われ、利用企業が当該ONE CAREER会員に対して内定の意思表示を行い、当該ONE CAREER会員がこれを受諾することをいいます。

j. 内定辞退：内定承諾をしたONE CAREER会員が、利用企業に対して内定承諾を撤回する旨の意思表示を行い、利用企業がこれを受諾することをいいます。

k. 入社：(i) 利用企業と利用企業に対して内定承諾を行ったONE CAREER会員とが合意した入社日が到来し（ただし、当該入社日前に内定者の内定辞退その他の理由により内定関係が終了している場合を除く。）、又は、(ii) 当該ONE CAREER会員が利用企業において実質的な勤務（研修、アルバイト等を含みます。）を開始することをいいます。



## 第3条（適用の範囲）
本利用規約は、次条の定めに従い、本利用規約（変更後を含みます。）に同意した利用企業に対して適用するものとします。



## 第4条（本利用規約への同意及び本契約の成立）
1. 利用企業は、本サービスの利用について、本利用規約の内容に同意した上で、当社所定の申込書等に当社所定の必要事項を記入し、これを当社に交付、送付又は送信することにより、本契約を申し込むものとします。利用企業が当該申込みを行った場合、当社の同意なく、当該申込みの意思表示の変更、取消又は撤回はできないものとします。利用企業は、申込書等の内容に変更が生じ、その他申込書等の内容を訂正、変更する必要が生じた場合には、直ちに当社に通知するものとします。
2. 当社は、前項の申込みに対し当社の取引基準に基づく審査により適格と判断した場合、利用企業に対し、前項の申込みに対する承諾の意思表示を行います。この場合、利用企業は、当社の別途定める時以降、本利用規約の定めに従い、本サービスを利用することができます。
3. 利用企業が第1項の申込みを行った時又は本サービスの利用を開始した時のいずれか早い時に、利用企業は本利用規約に同意したものとします。



## 第5条（本サービスの定義）
利用企業は、当社に対し、次の各号に定める業務（以下、「本サービス」という。）を委託し、当社は、これを受託するものとします。当社は、本サービスの利用期間中、必要に応じまたは利用企業の求めに基づき、利用企業のために本業務を実施するものとします。

a. 利用企業が求める⼈材の紹介

b. ⼈材採⽤計画の⽴案および遂⾏のための助⾔

c. aおよびbに付随関連する業務



## 第6条（求⼈の申込み）
1. 利用企業は、本サービスの利用期間中、当社に対して、求⼈条件を可能な限り速やかに明⽰して、当社に対して求⼈の申込みをするものとし、当社が求⼈票を受領した時点で、求⼈の申込みがあったものとみなします。かかる求⼈条件の明⽰は、当社に対し、求⼈票を⼿交もしくは郵送にて交付することにより⾏うものとします。但し、当社が同⽂書を電⼦メールに添付して送付する⽅法により⾏うことを希望した場合には、利用企業は、当該⽅法により、求⼈条件の明⽰を⾏うものとします。
2. 利用企業は、前項の申込みを⾏うに際しては、虚偽、もしくは法令等（平成11年厚⽣労働省告⽰第141号「職業紹介事業者、求⼈者、労働者の募集を⾏う者、募集受託者、募集情報等提供事業を⾏う者、労働者供給事業者、労働者供給を受けようとする者等が均等待遇、労働条件等の明⽰、求職者等の個⼈情報の取扱い、職業紹介事業者の責務、募集内容の的確な表⽰、労働者の募集を⾏う者等の責務、労働者供給事業者の責務等に関して適切に対処するための指針」（その後の改正を含み、以下「本指針」という。）を含む。以下同じ。）に違反する求⼈条件、または通常の求⼈条件と⽐して著しく不適当な求⼈条件、その他職業安定法第5条の6第1項各号に該当する求⼈条件をもって、当社に対して求⼈の申込みをしてはならないものとします。当社は、かかる求⼈の申込みがあった場合には、それを受理しないことができます。



## 第7条（申込み後の労働条件の変更等）
1. 利用企業は、前条第1項の申込みをした後、求⼈票において明⽰した求⼈条件の内容を変更、特定、削除または追加（以下、総称して「変更等」という。）を⾏う場合には、当社に対し、可能な限り速やかに、本指針第二・三（三）イまたはロに定める書⾯を⼿交もしくは郵送にて交付する⽅法（但し、当社が希望した場合には、同書⾯を電⼦メールに添付して送付する⽅法）により、当該変更等を⾏う求⼈条件を明⽰するものとします。
2. 前条第1項の規定に基づき明⽰した求⼈条件の内容に変更等が⽣じた時期が、利用企業が、当社から紹介を受けた⼈材と⾯接等の接触をした後であった場合には、利用企業は、本指針第二・三（三）イまたはロに定める書⾯を書⾯での⼿交もしくは郵送により交付する⽅法（但し、当該⼈材および当社が希望する場合には、同書⾯を電⼦メールに添付して送付する⽅法）により、直接当該⼈材および当社に対して明⽰するものとします。



## 第8条（紹介の内容）
当社は、応募者を利用企業に対して紹介しますが、応募があることを保証するものではありません。



## 第9条（採⽤選考）
1. 利用企業は、当社が前条により紹介した応募者を⾃ら選考のうえ、適当と認めた場合には、利用企業の責任において当該応募者を労働者として採⽤します。この際、当社は利用企業に採⽤選考について、当社の裁量により、適宜アドバイスを⾏い、その他の⽀援を⾏うものとします。
2. 利用企業は、前項に基づき応募者の採⽤を決定した場合、当社に対して、直ちに、当該応募者の採⽤を決定した事実および当該応募者に係る理論年収（別途申込書等に定める⽅法により算出するものとします。）の額を記載した⽂書（以下、「内定確認書」という。）を⼿交もしくは郵送による交付し、または同⽂書を電⼦メールに添付して送付する⽅法により交付するものとします。



## 第10条（利用企業の義務）
1. 利用企業が⾃らの費⽤と責任にて作成・公開するウェブ上の採⽤ページ（以下、「利用企業HP」という。）に対して、本契約に基づかずに直接応募した候補者が、本契約に基づき当社から利用企業に紹介された場合、当該候補者の意思に基づき、その選考⽅法を決定するものとします。但し、利用企業HPへの候補者による直接応募が、当社から利用企業への紹介よりも前に⾏われた場合には、利用企業HPへの候補者による直接応募を優先し、本契約に基づいて当社から利用企業に紹介されたものとは取り扱わないものとします。また、利用企業HPへの直接応募以外の⽅法で、かつ本契約に基づかずに利用企業に応募（他の⼈材紹介会社による紹介を通じての応募を含む。）した候補者が、本契約に基づき当社から利用企業に紹介された場合には、応募⽇と紹介⽇を⽐較して早いものを優先して取り扱うものとします。
2. 利用企業は、当社が応募者を紹介した⽇より1年間は、当該応募者の選考が終了した後であっても、紹介を受けた応募者と直接連絡を取る場合には、事前に当社から書⾯又は電子メールによる承諾を得なければならないものとします。但し、利用企業が当該応募者の採⽤を決定した場合はこの限りでありません。
3. 利用企業および当社は、採⽤を決定した応募者が利用企業に内定承諾した時点をもって、利用企業の当社に対する第12条に定める紹介⼿数料の⽀払義務が発⽣することを確認します。



## 第11条（労働条件の確認）
利用企業は、第9条第1項に基づき応募者の採⽤を決定した場合には、当該応募者に対して、労働基準法第15条に基づく労働条件明⽰書⾯を利用企業の責任において交付し、利用企業および当該応募者との間で雇⽤契約を締結するものとします。



## 第12条（対価）
1. 利用企業は、当社が本サービスに基づき紹介した応募者を採⽤し、内定承諾に⾄った場合、当社に対し、本業務の対価として、別途申込書等に定める紹介⼿数料およびその消費税相当額を、第4項に定める⽅法により⽀払います。ただし、内定承諾に⾄った⽇が本契約の終了⽇より後であった場合でも、第4項に定める⽅法により対価を⽀払う義務があるものとします。この場合、利用企業および当社は、内定時において、当該応募者の⽒名、⼊社予定⽇、理論年収、紹介⼿数料の額等必要な事項を内定確認書により確認するものとします。
2. 応募者が内定を辞退した場合、もしくは利用企業に⼊社した月以内に、明らかに当該応募者の責により解雇されるに⾄ったと当社が認めた場合、または当該応募者が⾃⼰都合によって退職したと当社が認めた場合（ただし、退職勧奨による場合、ハラスメント等の責めに帰すべき事由による退職であると当社が合理的理由に基づき判断した場合を除きます。）は、当社は、利用企業に対し、前項の定めに基づき受領した紹介⼿数料の全部または⼀部（入社後の退職については、受領した紹介⼿数料の半額）を、別途申込書等に定めた要領で返還するものとします。ただし、紹介⼿数料のうち未受領額がある場合には、返還額と対当額で相殺するものとし、相殺後にも残⾼がある場合には、利用企業は、直ちに当社に対し当該残⾼を⽀払うものとします。
3. 前項に定める場合を除き、当社は、第1項の定めに基づき受領した紹介⼿数料を⼀切返還しないものとします。
4. 利用企業は、応募者が利用企業に内定承諾した⽇の属する⽉の翌⽉末⽇（当該⽇が⾦融機関の⾮営業⽇であった場合は直前の営業⽇）までに、請求された紹介⼿数料およびその消費税相当額を、当社の別途指定する⾦融機関⼝座に振込送⾦する⽅法により⽀払うものとします。その際に発⽣する振込⼿数料は利用企業が負担するものとします。



## 第13条（個⼈情報の取扱い）
1. 当社は、利用企業の求めに応じて、利用企業が応募者を選考するにあたって必要と認められる限度において、また法令等に違反しない限度において、応募者の⽒名、連絡先、職務経歴等の個⼈情報（以下、「個⼈情報」という。）を利用企業に対して開⽰・提供するものとします。ただし、応募者の病歴、併願状況などの求⼈条件に何ら関連のない個⼈情報については、当該応募者の個別の承諾を事前に得ない限り、利用企業に対して開⽰・提供しないものとします。
2. 利用企業は、前項に基づき当社より提供された応募者（採⽤に⾄らなかった者も含む。）の個⼈情報を、善良なる管理者の注意をもって秘密として厳重に管理し、採⽤選考の⽬的の範囲内で保管および使⽤するものとし、本契約の有効期間中および本契約終了後も、採⽤選考に直接関与する部⾨の利用企業の役職員以外の第三者に開⽰または漏洩してはなりません。
3. 利用企業は、応募者の採⽤選考業務の全部または⼀部を第三者に委託する場合は、事前に書⾯または電⼦メールを利⽤する⽅法によりその旨当社に通知しなければなりません 。この場合、利用企業は、当該第三者において個⼈情報の安全管理が図られるように、⾃らの責任において、⾃らが⾏う措置と同様の安全管理措置を講じさせるものとします。



## 第14条（求⼈条件等の開⽰・公開）
当社は、利用企業が求⼈票に記載した求⼈条件および⼀般的に公開されている利用企業の企業情報を、当社が候補者を募集するために当社が運営、提供または指定するインターネットウェブサイト等において開⽰・公開する際には、利用企業の事前の承諾を得るものとします。



## 第15条（候補者への開⽰・提供）
当社は、利用企業の企業情報のうち、次の各号に定める情報について、候補者に対して開⽰・提供することができるものとします。ただし、利用企業が提供する情報のうち、利用企業が候補者に対して開⽰・提供を希望しない旨を事前に書⾯または電⼦メールを利⽤する⽅法により指定した情報については、この限りではありません。

a. 求⼈票のほか、利用企業から提供された情報

b. 当社が独⾃に収集した情報（ただし公開情報に限る。）



## 第16条（機密保持）
1. 利用企業および当社は、本契約の履⾏に伴い相⼿⽅から開⽰を受けた相⼿⽅の情報について、以下各号で定める情報を除き、機密を保持し、相⼿⽅の事前の承諾なく、本契約の⽬的以外に使⽤し、第三者に漏洩もしくは開⽰しないものとします。
    1. 相⼿⽅から開⽰を受ける前に、既に⾃⼰が保有していた情報
    2. 相⼿⽅から開⽰を受ける前に、既に公知となっている情報
    3. 相⼿⽅から開⽰を受けた後に、⾃⼰の責によらずに公知または公⽤となった情報
    4. 正当な権限を有する第三者から機密保持義務を負うことなく適法に⼊⼿した情報
    5. 相⼿⽅から開⽰を受けた情報によらず、独⾃に開発した情報
2. 利用企業および当社は、本契約の履⾏に伴う個⼈データの取扱いにつき、個⼈情報の保護に関する法律その他個⼈情報の取り扱いに関する法令の内容を遵守することを確認します。



## 第17条（早期離職者に関する情報提供）
1. 利用企業は、第9条第1項に基づき利用企業が採⽤した候補者のうち、期間の定めのない労働契約を締結した候補者について、当該候補者が利用企業に⼊社した⽇から6ヶ⽉が経過した⽇から1週間以内に、当該⽇において当該候補者が利用企業を退職したか否かを、当社に書⾯または電⼦メールを利⽤する⽅法により報告しなければなりません。
2. 当社は、利用企業に対し、第9条第1項に基づき利用企業が採⽤した候補者について、利用企業を退職したか否かを照会することができるものとし、利用企業が当社から当該照会を受けた場合は、誠実に調査した上で、回答しなければなりません。



## 第18条（本サービスの利用期間）
本契約は、別途申込書等に定める契約開始⽇から発効し、以後1年間有効とします。ただし、期間満了の1ヶ⽉前までに利用企業当社いずれか⼀⽅による解約の申し⼊れがない場合には、更に1年間、本契約を更新するものとし、以降も同様とします。



## 第19条（解除）
1. 利用企業および当社は、相⼿⽅が本契約に違反した場合または本契約を継続し難いと認められる事由が相⼿⽅に⽣じた場合には、本契約の有効期間中においても、事前に相⼿⽅に書⾯で通知することにより、本契約の全部または⼀部を解除することができます。
2. 利用企業および当社は、相⼿⽅が次の各号のいずれか⼀つに該当したときは、何らの通知催告なくして直ちに本契約の全部または⼀部を解除することができます。
    1. 本契約に定める条項に違反し、相⼿⽅に対し催告したにもかかわらず、催告した⽇から14⽇以内に当該違反が是正されないとき
    2. 監督官庁より営業の許可取消し、停⽌等の処分を受けたとき
    3. ⽀払停⽌もしくは⽀払不能の状態に陥ったとき、または⼿形もしくは⼩切⼿が不渡りとなったとき
    4. 第三者より差押え、仮差押え、仮処分もしくは競売の申⽴て、または公租公課の滞納処分を受けたとき
    5. 破産⼿続開始、⺠事再⽣⼿続開始、会社更⽣⼿続開始、特別清算⼿続開始の申⽴てを受けまたは⾃ら申⽴てを⾏ったとき
    6. 解散、会社分割、事業譲渡、または合併の決議をしたとき
    7. 資産または信⽤状態に重⼤な変化が⽣じ、本契約に基づく債務の履⾏が困難になるおそれがあると認められるとき
    8. その他前各号に準じる事由が⽣じたとき



## 第20条（本契約の変更・終了）
1. 本契約の変更は、利用企業および当社の書⾯による合意によってのみ⾏うことができるものとします。
2. 次に掲げる事由のいずれか⼀つに該当する場合、本契約は終了します。
    1. 利用企業および当社が書⾯により本契約の終了を合意した場合
    2. 本契約の規定に基づき本契約が解除された場合
3. 前項に基づき本契約が終了した場合であっても、第10条第2項（利用企業の義務）、第12条第1項および第3項（対価）、第13条第2項および第3項（個⼈情報の取扱い）、本項、第16条（機密保持）、第22条（損害賠償）、第27条（準拠法・合意管轄）の規定は、引き続きその効⼒を有します。
4. 当社が利用企業に対し応募者を紹介した後に、本契約の内容の全部もしくは⼀部が変更され、または本契約が終了した場合であっても、当該応募者については紹介時における契約条件が適⽤されるものとします。



## 第21条（期限の利益の喪失）
1. 当事者の⼀⽅が本契約に定める条項に違反した場合、相⼿⽅の書⾯による通知により、相⼿⽅に対する⼀切の債務について期限の利益を喪失し、直ちに相⼿⽅に弁済しなければなりません。
2. 当事者の⼀⽅に第19条第2項各号のいずれかに該当する事由が発⽣した場合、相⼿⽅からの何らの通知催告がなくとも、相⼿⽅に対する⼀切の債務について当然に期限の利益を喪失し、直ちに相⼿⽅に弁済しなければなりません。



## 第22条（損害賠償）
利用企業または当社は、本契約に違反し、相⼿⽅に損害を与えた場合には、相⼿⽅に対しその損害を賠償しなければなりません。ただし、当社の利用企業に対する賠償額は、損害が発⽣した⽇の直近1年間に利用企業が当社に⽀払った紹介⼿数料およびその消費税相当額の総額を上限とします。



## 第23条（反社会的勢⼒の排除）
1. 利用企業および当社は、本契約締結時において、利用企業と当社の各々（利用企業または当社の役員、実質的に経営権を有する者または経営に実質的に関与しているもの等を含む。以下、本項において同じ。）が次の各号に該当しないことを表明し、保証します。
    1. 暴⼒団、暴⼒団構成員、暴⼒団準構成員、暴⼒団関係企業、総会屋、社会運動標榜ゴロ、政治活動標榜ゴロ、特殊知能暴⼒集団等（以下、「暴⼒団等」という。）
    2. 暴⼒団等が経営を⽀配すると認められる関係を有すること
    3. 暴⼒団等が経営に実質的に関与していると認められる関係を有すること
    4. ⾃⼰、⾃社もしくは第三者の不正の利益を図る⽬的または第三者に損害を加える⽬的をもってするなど、不当に暴⼒団等を利⽤していると認められる関係を有すること
    5. 暴⼒団等に対して資⾦を提供し、または便宜を供与するなどの関与をしていると認められる関係を有すること
    6. 役員または経営に実質的に関与している者が暴⼒団等と社会的に⾮難されるべき関係を有すること
    7. 暴⼒団等または前各号のいずれか⼀にも該当する者またはこれらに準ずる反社会的集団または個⼈と⼈的、資本的および経済的に深い関係を有すること
    8. その他前各号に準ずること
2. 利用企業または当社は、相⼿⽅につき次の各号のいずれかに該当した場合は、通知催告その他の⼿続を要しないで、本契約の全部または⼀部を解除することができ、また、受けた損害の賠償を請求することができます。
    1. 前項各号に該当した場合
    2. 次のいずれかの⾏為を⾏うまたはその恐れがあると認められた場合

        i. 詐術、暴⼒的⾏為または脅迫的⾔辞を⽤いる⾏為またはこれに準ずる⾏為<br />
        ii. 違法⾏為、不当要求⾏為またはこれらに準ずる⾏為<br />
        iii. 業務を妨害する⾏為またはこれらに準ずる⾏為<br />
        iv. 名誉や信⽤等を毀損する⾏為またはこれに準ずる⾏為
3. 利用企業および当社は、相⼿⽅が前項各号のいずれか⼀でも違反することが疑われる合理的な事情がある場合には、当該違反の有無につき相⼿⽅の調査を⾏うことができ、相⼿⽅はこれに協⼒します。また、利用企業および当社は、⾃らが前項のいずれか⼀にでも違反し、またはその恐れがあることが判明した場合には、相⼿⽅に対し直ちにその旨を通知しなければなりません。
4. 利用企業または当社は、第2項に基づく解除により相⼿⽅が被った損害につき、⼀切の義務および責任を負わないものとします。



## 第24条（権利義務の譲渡禁⽌）
利用企業および当社は、相⼿⽅の事前の書⾯による同意なく、本契約により⽣じた契約上の地位を移転し、または本契約により⽣じた⾃⼰の権利義務の全部もしくは⼀部を、第三者に譲渡し、もしくは第三者の担保に供することはできないものとします。



## 第25条（本利用規約の変更）
1. 当社は本利用規約を変更する場合、電子メールまたは企業管理画面上で、利用企業に告知するものとします。変更後の本利用規約は、当社が別途定める場合を除いて、電子メールまたは企業管理画面上のどちらかに表示した時点より効力を生じるものとし、電子メールまたは企業管理画面上に掲載されている利用規約をもって、効力のある最新の利用規約とします。
2. 利用企業が、本利用規約の変更の効力が生じた後に本サービスを利用した場合には、変更後の本利用規約の全ての記載内容に同意したものとみなされ、当社と利用企業の間の本契約の内容は、変更後の利用規約に基づき定められるものとします。



## 第26条（協議事項）
本利用規約に定めのない事項および本利用規約の各条項に関する解釈の疑義については、法令の規定および慣習に従うほか、利用企業と当社の双⽅が誠意をもって協議し、解決を図るものとします。



## 第27条（準拠法・合意管轄）
本利用規約において定める事項及び本契約は日本法を準拠法とし、本契約に関して生じる一切の紛争については、東京地方裁判所又は東京簡易裁判所を第一審の専属的合意管轄裁判所とするものとします。



制定日　2023年12月1日
`;
